export const selectPollById = (state, cardId) => state.poll.polls[cardId];

export const selectHasVoted = (state, cardId) => {
  const poll = selectPollById(state, cardId);

  return !!poll && !!poll.userVotes && poll.userVotes.length > 0;
};
